import { HttpClient, HttpClientRequest, HttpClientResponse } from '@effect/platform';
import { Effect, pipe } from 'effect';
import { SiloTokenPriceBody } from './types';
import { BigIntWithDecimals, USD_DECIMALS } from '@silo/types';

export function getSiloTokenPriceEffect() {
  return Effect.gen(function* () {
    const { priceUsd } = yield* pipe(
      HttpClientRequest.get('/api/silo-token-price'),
      HttpClient.fetchOk,
      Effect.andThen(HttpClientResponse.schemaBodyJson(SiloTokenPriceBody)),
      Effect.scoped
    );

    return priceUsd;
  });
}

export async function getSiloTokenPrice() {
  const value = await pipe(getSiloTokenPriceEffect(), Effect.runPromise);

  const bi: BigIntWithDecimals = {
    value,
    decimals: USD_DECIMALS,
  };

  return bi;
}
